module.exports = __webpack_public_path__ + "static/media/transferencias.50bff9d4.svg";